<!-- ::START::LICENCE::
Copyright eQualityTime ©2018, ©2019, ©2020, ©2021, ©2022, ©2023, ©2024, ©2025
This file is part of OVFPlayer.
OVFPlayer is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.
OVFPlayer is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.
You should have received a copy of the GNU General Public License
along with OVFPlayer.  If not, see <https://www.gnu.org/licenses/>.
::END::LICENCE:: -->
<app-obfpage>
  <mat-card appearance="outlined" class="errorCard">
    <h2>
      Oh no! Something went wrong!
    </h2>
    @if (error) {
      <table>
        <tr>
          <td class="label">Location</td>
          <td><pre class="message">{{error.location}}</pre></td>
        </tr>
        <tr>
          <td class="label">Message</td>
          <td><pre class="message">{{error.message}}</pre></td>
        </tr>
        <tr>
          <td class="label">Cause</td>
          <td><pre class="message">{{error.causeChain}}</pre></td>
        </tr>
      </table>
    }
    <button mat-raised-button (click)="goToConfig()">Go to config page (you can select default boards from here if needed)</button>
    <p>If you need help resolving this issue or believe it may be an issue on our side, please don't hesitate to contact us.</p>
    @if (error) {
      <a [href]="errorHRef" target="_top" mat-raised-button>Send error report</a>
    }
  </mat-card>
</app-obfpage>
